var mobilesearch = {
    searchmodal: null,
    searchmodalbutton: null,
    searchmodalclear: null,

    init: function () {
        this.searchmodal = document.getElementById('search-modal');
        this.searchmodalclear = document.getElementById('search-modal-clear');
        this.searchmodalbutton = document.getElementById('mobile-search');
        if (this.Valid()) {
            this.Say('Mobile Search Loaded');
            this.AddEvents();
        }
    },

    Valid: function () {
        if (
            mobilesearch.searchmodal != null &&
            mobilesearch.searchmodalbutton != null &&
            mobilesearch.searchmodalclear != null
        ) {
            return true;
        } else {
            return false;
        }
    },

    AddEvents: function () {

        this.searchmodalbutton.addEventListener('click', function () {
            mobilesearch.searchmodal.classList.add('open');
            mobilesearch.searchmodal.getElementsByTagName("input")[0].focus();

        })
        this.searchmodalclear.addEventListener('click', function () {
            mobilesearch.searchmodal.classList.remove('open');
        })
    },

    Say: function(str){
        console.log('mobile-search.js: ' + str);
    }
}

export default mobilesearch;
